module.exports = __webpack_public_path__ + "static/media/paste.c01053f5.svg";